import { CellSelection } from "./CellSelection";
import { LineSelection } from "./LineSelection";
import { AnchoredPluginsHandler } from "../AnchoredPluginsHandler";

/**
 * @description Selection wrapper over all the other selection types
 */
export const SelectionWrapper = (function () {
    const instance = {};
    class SelectionWrapper {
        instaceUuid;

        cellIndependentHandler;

        lastSelected;

        constructor(diagramInstanceUuid) {
            if (!instance[diagramInstanceUuid]) {
                // setting the singleton instance
                instance[diagramInstanceUuid] = this;
                this.instaceUuid = diagramInstanceUuid;
                this.cellSelection = new CellSelection(this.instaceUuid);
                this.lineSelection = new LineSelection(this.instaceUuid);
                this.anchoredPluginsHandler = new AnchoredPluginsHandler(this.instaceUuid);
            }
            return instance[diagramInstanceUuid];
        }

        /**
         * @description sets the cell independent handler
         * @param {*} cellIndependentHandler
         */
        setCellIndependentHandler(cellIndependentHandler) {
            this.cellIndependentHandler = cellIndependentHandler;
        }

        /**
         * @description sets the selected value
         * @param {String} type - the type of the element being selected
         * @param {Object} val - the element being selected
         * @param {Object} aditional -aditional parameters to be sent to the individual handler  when called for selection
         */
        setSelected(type, val, aditional) {
            const cellVal = type === "CELL" ? val : null;
            const lineVal = type === "LINE" ? val : null;
            const anchoredVal = type === "ANCHORED_ELEM" ? val : null;
            const cellIndepVal = type === "CELL_INDEP" ? val : {};
            this.cellSelection.setSelectedCell.apply(this.cellSelection, this.getAditionalParams(cellVal, aditional));
            this.lineSelection.setSelectedLine.apply(this.lineSelection, this.getAditionalParams(lineVal, aditional));
            this.cellIndependentHandler.setSelected.apply(this.cellIndependentHandler, this.getAditionalParams(undefined, cellIndepVal));
            this.anchoredPluginsHandler.setSelected.apply(this.anchoredPluginsHandler, this.getAditionalParams(anchoredVal, aditional));
            this.lastSelected = { type, val };
        }

        /**
         * @description emit double click event (Connector)
         */
        handleDoubleClickSelection() {
            this.lineSelection.handleDoubleClickEvent();
        }

        /**
         * @description resets specific types of selection based on the types provided
         * @param {String[]} types - the selection handlers to be reset
         */
        resetSpecific(types) {
            if (!Array.isArray(types)) {
                types = [types];
            }
            types.forEach(type => {
                if (type === "CELL") {
                    this.cellSelection.setSelectedCell(null);
                }
                if (type === "LINE") {
                    this.lineSelection.setSelectedLine(null);
                }
                if (type === "CELL_INDEP") {
                    this.cellIndependentHandler.setSelected(null);
                }
                if (type === "ANCHORED_ELEM") {
                    this.anchoredPluginsHandler.setSelected(null);
                }
            });
        }

        /**
         * @description creates a array of parameters
         */
        getAditionalParams(value, aditional) {
            const val = [];
            if (value !== undefined) {
                val.push(value);
            }
            if (aditional) {
                for (const key in aditional) {
                    val.push(aditional[key]);
                }
            }
            return val;
        }

        /**
         * @description destroys the current instance based on the instanceUuid provided
         * @param {*} instanceUuid
         */
        destroy(instanceUuid) {
            this.cellSelection = null;
            this.lineSelection = null;
            this.lastSelected = null;
            instance[instanceUuid] = null;
            delete instance[instanceUuid];
        }

        /**
         * @description returns the last element selected
         * @param {*} type
         */
        getSelected(type) {
            if (type === "CELL") {
                return this.lastSelected && this.lastSelected.type === "CELL" ? this.lastSelected.val : null;
            }
            if (type === "LINE") {
                return this.lastSelected && this.lastSelected.type === "LINE" ? this.lastSelected.val : null;
            }
            if (type === "CELL_INDEP") {
                return this.lastSelected && this.lastSelected.type === "CELL_INDEP" ? this.lastSelected.val : null;
            }
            if (type === "ANCHORED_ELEM") {
                return this.lastSelected && this.lastSelected.type === "ANCHORED_ELEM" ? this.lastSelected.val : null;
            }
            return null;
        }
    }
    return SelectionWrapper;
}());
